module.exports = __webpack_public_path__ + "static/media/iconLoader.b52e9cb7.svg";